var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import useService from "../../../Hooks/useService";
import SecondaryNavLayout from "../../../Layout/SecondaryNavLayout";
import SecondaryNavButton from "../../../UI/SecondaryNav/SecondaryNavButton";
import ContentLayout from "../../../Layout/ContentLayout";
import ServiceResult from "../../../UI/ServiceResult/ServiceResult";
import { BasicFormFormat } from "../../../UI/FormFormat/FormFormat";
import { getAreaOfStudyDetailPath } from "./AreaOfStudyRoutes";
import AreaOfStudyService from "../../../../Services/AreaOfStudy.service";
import AreaOfStudyForm, { getAreaOfStudySaveRequest, } from "../../../Presentational/AreaOfStudy/AreaOfStudyForm";
import PageTitle from "../../../UI/PageTitle/PageTitle";
const AreaOfStudyEdit = () => {
    const saveButtonRef = useRef(null);
    const history = useHistory();
    const [areaOfStudyState, loadAreaOfStudy] = useService(AreaOfStudyService.get);
    const params = useParams();
    const id = parseInt(params.id, 10);
    React.useEffect(() => {
        if (id) {
            loadAreaOfStudy(id);
        }
    }, [id, loadAreaOfStudy]);
    return (_jsx(SecondaryNavLayout, { nav: _jsxs("div", { className: "d-flex", children: [_jsx(SecondaryNavButton, { icon: "save", label: "Save", title: "Save", iconType: "fas", onClick: () => {
                        var _a;
                        (_a = saveButtonRef.current) === null || _a === void 0 ? void 0 : _a.click();
                    } }), _jsx(Link, { to: getAreaOfStudyDetailPath(id), title: "Cancel", tabIndex: -1, children: _jsx(SecondaryNavButton, { icon: "times", label: "Cancel", title: "Cancel", iconType: "fas" }) })] }), children: _jsxs(ContentLayout, { paddingTop: true, paddingBottom: true, whiteBackground: true, children: [_jsx(PageTitle, { className: "pb-2", children: "Edit Area Of Study" }), _jsx(ServiceResult, { state: areaOfStudyState, children: (areaOfStudy) => (_jsx(BasicFormFormat, { saveButtonRef: saveButtonRef, handleSubmit: (formState) => __awaiter(void 0, void 0, void 0, function* () {
                            return AreaOfStudyService.save(getAreaOfStudySaveRequest(formState)).then((response) => {
                                history.push(getAreaOfStudyDetailPath(response.id));
                            });
                        }), defaultValue: {
                            id: areaOfStudy.id,
                            name: areaOfStudy.name,
                            active: areaOfStudy.active,
                            code: areaOfStudy.code,
                            areaOfStudyType: areaOfStudy.areaOfStudyType,
                            sisImportCreatedDate: areaOfStudy.sisImportCreatedDate,
                            sisImportModifiedDate: areaOfStudy.sisImportModifiedDate,
                        }, errorMessagePosition: "top", hideButtons: true, children: _jsx(AreaOfStudyForm, { areaOfStudy: areaOfStudy }) })) })] }) }));
};
export default AreaOfStudyEdit;
